/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';
import _get from 'lodash/get';
import _size from 'lodash/size';
import _findIndex from 'lodash/findIndex';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { connect } from 'react-redux';
import { readCookie } from '../../../../src/utils/Cookie';
import {
  addAddress,
  editAddress,
  postalCodeFetch,
  setPinCode,
  setPostalCode,
  resetPostalData,
  setDelivery,
  setCheckedAddress
} from '../../actions/addressBook';
import { hideModal } from '../../../actions/modal';
import {
  validateMobile,
  validateUsername,
  validatePincode,
  validateASCIIChars,
  validateFirstName,
  validateOthersAddressName,
  validateLandmark
} from './../../../utils/inputValidator';
import { changeAddressSelectionOnCart, getCart } from '../../../cart/actions/cart';
import { isServerRendering } from '../../../utils/pageInfo.js';
import { fetchCartItemsEDDFromClient } from '../../../edd/actions/index.js';
import cleverTapPushEvent from '../../../modules/ajio-util/cleverTap/eventUtils';
import CLEVERTAP_EVENT_NAMES from '../../../modules/ajio-util/cleverTap/eventConstants';
import Input from '../../../refresh/molecules/Input';
import Icon from '../../../refresh/atoms/Icon';
import Text from '../../../refresh/atoms/Text';
import { gtmEventPush, gtmPagePush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import { getDecodedString, getEncodedString } from '../../../modules/ajio-util/stringDecoder';
import BackArrow from '../../../refresh/atoms/BackArrow';
import Dialog from '../../../refresh/molecules/Dialog';
import ResetAddressLuxe from '../mobile/ResetAddressLuxe';
import { getLuxeFlags } from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import screen from '../../../refresh/constants/pageType.constant';
import luxeScreens from '../../../refresh/constants/luxeScreenType';
import { jioAdsLocationEvent } from '../../../utils/jioAds';
import readAloudFormErrors from '../../../utils/accessibility';
import { getGSTFlag } from '../../../refresh/selectors/featureFlagsSelector';

const userId = decodeURIComponent(readCookie('U')) || '';
const style = Object.freeze({
  fontSize: '1.8rem',
  fontWeight: 'bold'
});
const luxeStyle = Object.freeze({
  fontSize: '2.4rem',
  fontWeight: '500',
  top: '-10px'
});
const styles = {
  floatingLabelFocusStyle: {
    fontSize: '12px',
    left: '1px',
    color: '#6D6D6D'
  },
  inputStyle: {
    fontSize: '14px',
    height: '60px',
    paddingBottom: '8px',
    color: '#6D6D6D'
  },
  textAreaStyle: {
    fontSize: '14px',
    paddingBottom: '8px',
    color: '#6D6D6D'
  },
  floatingLabelShrinkStyle: {
    lineHeight: '2px',
    left: '1px',
    color: '#6D6D6D'
  },
  floatingLabelShrinkStyleTextArea: {
    left: '1px',
    color: '#6D6D6D'
  }
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#d4a048',
    }
  }
});

function isEDDRequired(url = '') {
  if (isServerRendering()) {
    return url.includes('/shipping') || url.includes('/addresses'); //have to check
  } else {
    const { location: { pathname = '' } = {} } = window;
    return pathname.includes('/shipping') || pathname.includes('/addresses');
  }
}

class AddAddress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.props,
      resetSuccessMessage:' ',
    };
    this.keyboardNavForAddressType = this.keyboardNavForAddressType.bind(this);
    let profileName =
      (props.personalInfo && props.personalInfo.profile && props.personalInfo.profile.name) || '';
    let addressPoc = (this.state.address && this.state.address.addressPoc) || '';
    if (this.props.addrFormType !== 'Edit') {
      addressPoc = addressPoc || profileName;
    }

    const { firstName = '', lastName = '' } = this.props.address || {};

    if (this.props.addrFormType === 'Edit' && addressPoc === '') {
      if (firstName.length + lastName.length > 63) {
        addressPoc = firstName;
      } else {
        addressPoc = firstName.trim() + ' ' + lastName.trim();
      }
    }
    if (this.props.gstBusinessName) {
      addressPoc = this.props.gstBusinessName;
    }
    (this.address = {
      ...this.state.address,
      phone:
        (this.state.address && this.state.address.phone) ||
        readCookie('MN') ||
        props.personalInfo.profile.mobileNumber,
      addressPoc
    }),
      (this.addAddressSubmit = this.addAddressSubmit.bind(this));
    this.state = {
      ...this.state,
      address: this.address,
      errAddressPoc: '',
      errLandmark: '',
      errLastName: '',
      errMob: '',
      errPinCode: '',
      errCityDistrict: '',
      errMobileNum: '',
      errAltMobNum: '',
      errAddressLine1: '',
      errAddressLine2: '',
      defaultBoxChecked: false,
      addressLine3: '',
      errState: '',
      errCustomAddress: '',
      removeFromBagModal: false
    };
    this._saveAddressCallback = this.saveAddressCallback.bind(this);
  }

  saveAddressCallback(addresses = []) {
    const { address = {} } = this.state;
    let { defaultAddress = '' } = address;
    let {
      addrFormType,
      isPageType,
      setCheckedAddress,
      callback,
      entryNumber,
      enableGST = false,
      device = '',
      disableCartUpdate = false
    } = this.props;

    const getSelectedAddedAddress = () => {
      const fallbackIndex = _size(addresses) === 1 || defaultAddress ? 0 : 1;
      const fallbackAddress = _get(addresses, [fallbackIndex], {});
      const normalizedLine1 = `${address?.line1 || ''}`.trim().toLowerCase();
      const normalizedPostalCode = `${address?.postalCode || ''}`.trim();
      const normalizedPhone = `${address?.phone || ''}`.trim();

      const matchedAddress = addresses.find(item => {
        const itemLine1 = `${item?.line1 || ''}`.trim().toLowerCase();
        const itemPostalCode = `${item?.postalCode || ''}`.trim();
        const itemPhone = `${item?.phone || ''}`.trim();
        return (
          itemLine1 === normalizedLine1 &&
          itemPostalCode === normalizedPostalCode &&
          itemPhone === normalizedPhone
        );
      });

      return matchedAddress || fallbackAddress || {};
    };

    if (isPageType == 'shipping') {
      let selectedAddressObj = {};
      if (addrFormType === 'Edit') {
        const indexOfEditedAddress = _findIndex(addresses, ['id', entryNumber]);
        selectedAddressObj = _get(addresses, [indexOfEditedAddress], {});
        setCheckedAddress(
          entryNumber,
          selectedAddressObj?.postalCode,
          indexOfEditedAddress
        );
      } else {
        selectedAddressObj = getSelectedAddedAddress();
        const selectedIndex = _findIndex(addresses, ['id', selectedAddressObj?.id]);
        const { id, postalCode } = selectedAddressObj;
        if (selectedIndex >= 0 && id && postalCode) {
          setCheckedAddress(id, postalCode, selectedIndex);
        }
      }
      if (enableGST && isPageType == 'shipping' && device !== 'mobile' && !disableCartUpdate) {
        const { id, postalCode } = selectedAddressObj;
        if (id && postalCode) {
          this.props.updateAddressOnCart({ addressId: id, pincode: postalCode });
        }
      }
    }
    if (this.props.callback) {
      this.props.callback(addresses, addrFormType);
    }
    const { location: { search = '' } = {} } = window || {};
    if (search.includes('shipping')) {
      if (this.props.addrFormType !== 'Edit') {
        window.location = '/shipping';
      }
    }
  }

  componentWillMount() {
    this.props.resetPostalData();
  }
  showDialog(e) {
    e.preventDefault();
    let { removeFromBagModal } = this.state;

    this.setState({ removeFromBagModal: !removeFromBagModal });
  }
  componentDidMount() {
    let { address = {}, addrFormType = '', isPageType = '', name, luxeFlags } = this.props;
    let { line1 = '', town = '', defaultAddress = false } = address;
    const { isThemeEnable } = luxeFlags;
    const luxe = isThemeEnable === 'ON' && name === 'luxe';
    const addressLine3 = town ? `${line1}, ${town}` : line1;
    this.setState({ addressLine3, defaultBoxChecked: defaultAddress });

    if (luxe) {
      const { defaultStore, addressSelection = {} } = luxeScreens;
      const { screenType = '', screenName = '' } = addressSelection;
      gtmEventPush({
        event: 'form_initiate',
        event_category: 'form interactions',
        event_action: 'Initiate',
        event_label: addrFormType == 'Edit' ? 'Edit address' : 'Add address',
        store_type: name || defaultStore,
        page_name: addrFormType == 'Edit' ? `Edit ${screenName}` : `Add ${screenName}`,
        page_type: screenType
      });
 // Segment PUSH event
      segmentEventPush({
        event: 'Add Address Clicked',
        event_category: 'form interactions',
        event_action: 'Initiate',
        event_label: addrFormType == 'Edit' ? 'Edit address' : 'Add address',
        store_type: name || defaultStore,
        screen_name: addrFormType == 'Edit' ? `Edit ${screenName}` : `Add ${screenName}`,
        page_type: screenType
      });

    } else {
      gtmEventPush({
        event: 'form_initiate',
        form_name: addrFormType == 'Edit' ? 'Edit address' : 'Add address'
      });
       // Segment PUSH event
      segmentEventPush({
        event: 'Add Address Clicked',
        form_name: addrFormType == 'Edit' ? 'Edit address' : 'Add address'
      });

           
      const { manageAddress: { pageType = '' } = {} } = screen;
      gtmPagePush(
        addrFormType == 'Edit'
          ? 'update address screen shipping'
          : 'create address screen shipping',
        pageType,
        window.__ENV__ || '',
        {
          store: name
        }
      );
    }
  }

  handleInputChange(newPartialInput) {
    let inputObjKey = Object.keys(newPartialInput)[0];
    let inputObjVal = Object.values(newPartialInput)[0];

    if (inputObjKey == 'addressPoc') {
      if (validateFirstName(inputObjVal)) {
        this.setState({
          errAddressPoc: ''
        });
      } else {
        this.setState({
          errAddressPoc: 'Accepts only alphabets & spaces between words.'
        });
      }
    }
    // if (inputObjKey == "firstName") {
    //   if (validateFirstName(inputObjVal)) {
    //     this.setState({
    //       errFirstName: ""
    //     })
    //   } else {
    //     this.setState({
    //       errFirstName: "Accepts only alphabets & spaces between words."
    //     })
    //   }
    // }
    else if (inputObjKey == 'landmark') {
      if (validateLandmark(inputObjVal)) {
        this.setState({
          errLandmark: ''
        });
      } else if (inputObjVal.length === 0) {
        this.setState({
          errLandmark: 'Enter a landmark'
        });
      } else {
        this.setState({
          errLandmark: 'Special characters are not allowed'
        });
      }
    }
    // else if (inputObjKey == "lastName") {
    //   if (validateUsername(inputObjVal)) {
    //     this.setState({
    //       errLastName: ""
    //     })
    //   }
    //   else {
    //     this.setState({
    //       errLastName: "Accepts only alphabets & spaces between words."
    //     })
    //   }
    // }
    else if (inputObjKey == 'postalCode') {
      if (validatePincode(inputObjVal)) {
        this.setState({
          errPinCode: ''
        });
      }
      else if(inputObjVal.length == 0){
        this.setState({
          errPinCode: 'Enter a pincode'
        });
      }
      else {
        this.setState({
          errPinCode: 'Enter valid Pincode'
        });
      }
    } else if (inputObjKey == 'line1') {
      this.setState({ addressLine3: inputObjVal });
      if (inputObjVal !== '') {
        this.setState({
          errAddressLine1: ''
        });
      } else {
        this.setState({
          errAddressLine1: 'Enter valid  Flat no/Building Name'
        });
      }
    } else if (inputObjKey == 'line2') {
      if (inputObjVal !== '') {
        this.setState({
          errAddressLine2: ''
        });
      } else {
        this.setState({
          errAddressLine2: 'Enter valid Locality / Area / Street'
        });
      }
    } else if (inputObjKey == 'district') {
      if (validateUsername(inputObjVal)) {
        this.setState({
          errCityDistrict: ''
        });
      } else {
        this.setState({
          errCityDistrict: 'Please enter a valid city/district.'
        });
      }
    } else if (inputObjKey == 'phone') {
      if (validateMobile(inputObjVal)) {
        this.setState({
          errMobileNum: ''
        });
      } else {
        this.setState({
          errMobileNum: 'Please enter a valid 10 digit mobile number.'
        });
      }
    } else if (inputObjKey == 'altMobNum') {
      if (validateMobile(inputObjVal)) {
        this.setState({
          errAltMobNum: ''
        });
      } else {
        this.setState({
          errAltMobNum: 'Please enter a valid 10 digit mobile number.'
        });
      }
    }
    if (inputObjKey == 'customAddressType') {
      if (validateOthersAddressName(inputObjVal)) {
        this.setState({
          errCustomAddress: ''
        });
      } else {
        this.setState({
          errCustomAddress: 'Accepts only alphabets & spaces between words.'
        });
      }
    }

    this.setState(state => ({
      ...state,
      address: {
        ...state.address,
        ...newPartialInput
      }
    }));
  }


  // NOTE : use this appraoch when fixing this issue with luxe as well
  // we are doing the following 
  // 1. we have given all error messages a unique id
  // 2. we are calling the below function on onClick of the button and not on onSubmit of the form because we want to announce the errors as well, with native form error handling the error messages are shown but announced.
  // 3. below function is used to check if any other errors are already present, if they are present then we simply jump the focus to that input. We are also checking if no errors are present and the input field is emptyBundleBannerImpressionArray, if it is then we add an error to it and jump the focus there (jump only when no pre-existing errors are present)
  checkIfFieldsEmptyOnSubmit = () => {
    const { address } = this.state;

    const fieldMap = {
      addressPoc: { errKey: "errAddressPoc", msg: "Enter a name" , errorMsgId:'name-error-msg'},
      phone: { errKey: "errMobileNum", msg: "Enter a mobile number",errorMsgId:"mobileNum-error-msg" },
      postalCode: { errKey: "errPinCode", msg: "Ender a pin code",errorMsgId:"pincode-error-msg" },
      line2: { errKey: "errAddressLine2", msg: "Enter a locality/area/street",errorMsgId:"line-2-error-msg" },
      line1: { errKey: "errAddressLine1", msg: "Enter a flat number/building name",errorMsgId:"line-1-error-msg" },
      landmark: { errKey: "errLandmark", msg: "Enter a landmark",errorMsgId:"lm-error-msg" },
      // cityDistrict: { errKey: "errCityDistrict", msg: "Enter a district/city",errorMsgId:"district-error-msg" },
    };

    let newErrors = {};

    let firstExistingErrorFound = false;
    let firstErrorFound = false;

    Object.keys(fieldMap).forEach(key => {
      const { errKey, msg } = fieldMap[key];
      // Skip this field if an error already exists
      if (this.state[errKey] && this.state[errKey].trim() !== "") {
        if (!firstExistingErrorFound) {
          const errorElement = document.getElementById(fieldMap[key]['errorMsgId']);
          const wrapper = errorElement.closest(".mobaddadddr-input");
          const input = wrapper.querySelector("input");
          if (input) {
            input.focus()
            firstExistingErrorFound = true;
          }
        }
        return;
      }

      // If field is empty → set error
      if (!address[key] || address[key].toString().trim() === "") {
        newErrors[errKey] = msg;

        // for the first error, find input element and move focus to it
        if(!firstErrorFound && !firstExistingErrorFound){
          const errorElement = document.getElementById(fieldMap[key]['errorMsgId']); 
          const wrapper = errorElement.closest(".mobaddadddr-input");
          const input = wrapper.querySelector("input");
          if(input){
            input.focus()
            firstErrorFound = true;
          }
        }
      }
    });

    if (Object.keys(newErrors).length > 0) {
      this.setState(newErrors);
    }
  };


  handleResetButton(event, initialaddresss = {}, luxe) {
    event.stopPropagation();
    event.preventDefault();
    let { name, addrFormType } = this.props;
    let { line1 = '', town = '' } = initialaddresss;

    const addressLine3 = town ? `${line1}, ${town}` : line1;
    // if(this.props.addrFormType === 'Add' ){
    // let {phone } = this.state.address;
    // initialaddresss.phone = phone;
    // let {addressPoc } = this.state.address;
    //   initialaddresss.addressPoc = addressPoc;
    // }

    this.props.resetPostalData();
    this.setState(state => ({
      ...state,
      defaultBoxChecked: this.address.defaultAddress,
      address: this.address,
      addressLine3,
      defaultAddress : false
    }));
    if (luxe) {
      const { defaultStore, addressSelection = {} } = luxeScreens;
      const { screenType = '', screenName = '' } = addressSelection;
      gtmEventPush({
        event: addrFormType == 'Edit' ? 'edit_reset' : 'add_reset',
        event_category: 'checkout interactions',
        event_action: addrFormType == 'Edit' ? 'Edit reset' : 'Add reset',
        event_label: addrFormType == 'Edit' ? 'Edit reset' : 'Add reset',
        store_type: name || defaultStore,
        page_name: addrFormType == 'Edit' ? `Update ${screenName}` : `Create ${screenName}`,
        page_type: screenType
      });
      this.setState({ removeFromBagModal: !this.state.removeFromBagModal });
    }
  }

  handlePostalCode(newPartialInput) {
    //Here Code to get the API Call
    let { postalCode = '' } = newPartialInput;
    if (postalCode.length == 6) {
      this.props.getlocationFromPostalCode(newPartialInput);
    }
    this.handleInputChange(newPartialInput);
  }

  checkMandatoryFields = (
    postalCode,
    addressPoc,
    line1,
    line2,
    district,
    phone,
    state,
    luxe,
    addrFormType
  ) => {
    let { name } = this.props;
    let { errLandmark } = this.state;
    let errorMsg = '';
    if (postalCode == '') {
      this.setState({
        errPinCode: 'Enter valid Pincode'
      });
      errorMsg = 'Enter valid Pincode';
    }
    if (addressPoc == '') {
      this.setState({
        errAddressPoc: 'Enter valid  Name'
      });
      errorMsg = 'Enter valid  Name';
    }
    // if (firstName == "") {
    //   this.setState({
    //     errFirstName: "Enter valid First Name"
    //   })
    // }
    // if (lastName == "") {
    //   this.setState({
    //     errLastName: "Enter valid Last Name"
    //   })
    // }
    if (validateASCIIChars(line1).trim().length === 0) {
      this.setState({
        errAddressLine1: 'Enter valid  Flat no/Building Name'
      });
      errorMsg = 'Enter valid  Flat no/Building Name';
    }
    if (validateASCIIChars(line2).trim().length === 0) {
      this.setState({
        errAddressLine2: 'Enter valid Locality / Area / Street'
      });
      errorMsg = 'Enter valid Locality / Area / Street';
    }
    if (district == '') {
      this.setState({
        errCityDistrict: 'Please enter a City/District'
      });
      errorMsg = 'Please enter a City/District';
    }
    if (state == '') {
      this.setState({
        errState: 'Please enter a state'
      });
      errorMsg = 'Please enter a state';
    }
    let isNotValidMobileNum =
      phone == '' || isNaN(phone) || phone.indexOf(' ') != -1 || phone.length !== 10;
    if (isNotValidMobileNum) {
      this.setState({
        errMobileNum: 'Please enter a valid 10 digit mobile number.'
      });
      errorMsg = 'Please enter a valid 10 digit mobile number.';
    }
    if (
      postalCode == '' ||
      addressPoc == '' ||
      validateASCIIChars(line1).trim().length === 0 ||
      validateASCIIChars(line2).trim().length === 0 ||
      district == '' ||
      state == '' ||
      isNotValidMobileNum ||
      errLandmark != ''
    ) {
      if (luxe) {
        const { defaultStore, addressSelection = {} } = luxeScreens;
        const { screenType = '', screenName = '' } = addressSelection;

        gtmEventPush({
          event: 'form_error',
          event_category: 'form interactions',
          event_action: 'error',
          event_label:
            addrFormType == 'Edit'
              ? `Update ${screenName} ${errorMsg}`
              : `Create ${screenName} ${errorMsg}`,
          store_type: name || defaultStore,
          page_name: addrFormType == 'Edit' ? `Update ${screenName}` : `Create ${screenName}`,
          page_type: screenType
        });
      }

      return false;
    } else {
      return true;
    }
  };

  scrollToError = () => {
    this.errorMessages.scrollIntoView({ behavior: 'smooth' });
  };

  addAddressSubmit = async (
    event,
    postalCode,
    addressPoc,
    line1,
    district,
    phone,
    line2,
    town,
    landmark,
    altMobNum,
    defaultAddress,
    state,
    selectedAddressType,
    customAddressType,
    luxe
  ) => {
    event.preventDefault();

    const {
      entryNumber,
      addrFormType,
      isPageType = '',
      editAddressCheckout,
      editAddress,
      setCheckedAddress,
      fetchCartItemsEDDFromClient,
      setDelivery,
      addAddress,
      name,
      enableGST = false,
      isBillingAddressFlow = false
    } = this.props;

    cleverTapPushEvent({
      eventName: CLEVERTAP_EVENT_NAMES.Address_Added,
      eventObj: {
        type: selectedAddressType,
        pinCode: postalCode,
        city: district,
        state: state,
        user_id: userId != 'null' ? userId : 'anonymous',
        platform: 'MSITE'
      }
    });
    if (luxe) {
      const { defaultStore, manageAddressMyAccount = {} } = luxeScreens;
      const { screenType = '', screenName = '' } = manageAddressMyAccount;
      gtmEventPush({
        event: 'form_submit',
        event_category: 'form interactions',
        event_action: 'submit',
        store_type: name,
        page_name: addrFormType == 'Edit' ? `Update ${screenName}` : `Create ${screenName}`,
        page_type: screenType
      });
    } else {
      const { defaultStore, addressSelection = {} } = luxeScreens;
      const { screenType = '', screenName = '' } = addressSelection;
      gtmEventPush({
        event: 'form_submit',
        event_category: 'form interactions',
        event_action: 'submit',
        page_name: screenName,
        page_type: screenType,
        form_name: addrFormType == 'Edit' ? 'Edit address' : 'Add address'
      });
    }
    const addressList = _get(this.props, 'addressBook.addresses', []);
    const mandatoryFieldsFilled = this.checkMandatoryFields(
      postalCode,
      addressPoc,
      line1,
      line2,
      district,
      phone,
      state,
      luxe,
      addrFormType
    );

    const addAddressluxeForm = document.getElementById('addAddressFormLuxe')
      ? document.getElementById('addAddressFormLuxe').elements
      : [];
    const addAddressForm = document.getElementById('addAddressForm')
      ? document.getElementById('addAddressForm').elements
      : [];

    const formData = luxe ? addAddressluxeForm : addAddressForm;

    let addAddrData = {};

    for (let idx = 0, len = formData.length; idx < len; idx++) {
      let { name = '', value = '', checked = false } = formData[idx] || {};
      if (name) {
        if (name == 'defaultAddress') {
          addAddrData[name] = checked;
        } else {
          if (name === 'selectedAddressType') {
            if (checked) {
              const validValue = validateASCIIChars(value);
              addAddrData[name] = getEncodedString(validValue.trim());
            }
          } else {
            const validValue = validateASCIIChars(value);
            addAddrData[name] = getEncodedString(validValue.trim());
          }
        }
      }
    }
    if (this.props.gstBusinessName) {
      const { firstName = '', lastName = '' } = this.props.personalInfo?.profile || {};
      addAddrData.addressPoc = `${firstName.trim()} ${lastName.trim()}`;
    }
    const { defaultStore, addressSelection = {} } = luxeScreens;
    const { screenType = '', screenName = '' } = addressSelection;
    if (enableGST && isPageType == 'shipping' && !isBillingAddressFlow) {
      addAddrData.defaultAddress = true;
    }
    //Dispactching an action to addAddress
    if (mandatoryFieldsFilled) {
      if (addrFormType == 'Edit') {
        addAddrData['id'] = entryNumber;
        if (isPageType == 'checkout') {
          editAddressCheckout(addAddrData);
        } else {
          editAddress(addAddrData, this._saveAddressCallback);
          luxe && this.props.onCancel();

          luxe &&
            gtmEventPush({
              event: 'edit_save',
              event_category: 'checkout interactions',
              event_action: 'edit save',
              event_label: 'Edit address',
              store_type: name,
              page_name: `Update ${screenName}`,
              page_type: screenType
            });
          if (isEDDRequired()) {
            fetchCartItemsEDDFromClient(addAddrData.postalCode).then(response => {
              if (response.status.statusCode === 0) {
                const { pinCode, servicability, codEligible } = response;
                if (!servicability) {
                  window.ga &&
                    window.ga('send', {
                      hitType: 'event',
                      eventCategory: 'buttonTap',
                      eventAction: 'EDD on Shipping Page',
                      eventLabel: `Proceed to payment disabled - ${pinCode}`
                    });
                }
              }
            });
          }
          const { location: { pathname = '', search = '' } = {} } = window || {};
          const isReferrerShippingPage =
            pathname.includes('/my-account/address-book') && search.includes('shipping');
          if (isReferrerShippingPage) {
            setDelivery(this.props.entryNumber);
          }
        }
        this.props.setPinCode(postalCode);
      } else {
        const { errLandmark } = this.state;
        mandatoryFieldsFilled && !errLandmark && addAddress(addAddrData, this._saveAddressCallback);
        luxe && this.props.onCancel();
        luxe &&
          gtmEventPush({
            event: 'add_new_save',
            event_category: 'checkout interactions',
            event_action: 'add new save',
            event_label: 'Add address',
            store_type: name || defaultStore,
            page_name: `Create ${screenName}`,
            page_type: screenType
          });
      }
    } else {
      this.scrollToError();
    }
    // window.location('/address-book');
  };
  hideDialog() {
    // setDialogData(null);
    this.setState({ removeFromBagModal: !this.state.removeFromBagModal });
  }
  goBack = () => window.history.back();

keyboardNavForAddressType = (container) => {
  if (!container) return;

  const radios = Array.from(
    container.querySelectorAll('input[type="radio"]')
  );

  if (!radios.length) return;

  // --- INITIAL SETUP (APG-compliant) ---
  const checkedRadio = radios.find(r => r.checked) || radios[0];

  radios.forEach(radio => {
    radio.tabIndex = radio === checkedRadio ? 0 : -1;
  });

  // --- KEYBOARD HANDLER ---
  const onKeyDown = (e) => {
    const { key } = e;

    if (
      key !== 'ArrowRight' &&
      key !== 'ArrowDown' &&
      key !== 'ArrowLeft' &&
      key !== 'ArrowUp'
    ) {
      return;
    }

    e.preventDefault(); // 🚫 prevent Tab-like behavior

    const currentIndex = radios.indexOf(document.activeElement);
    if (currentIndex === -1) return;

    let nextIndex = currentIndex;

    if (key === 'ArrowRight' || key === 'ArrowDown') {
      nextIndex = (currentIndex + 1) % radios.length;
    }

    if (key === 'ArrowLeft' || key === 'ArrowUp') {
      nextIndex = (currentIndex - 1 + radios.length) % radios.length;
    }

    // Update checked + tabindex
    radios.forEach((radio, index) => {
      const isActive = index === nextIndex;
      radio.checked = isActive;
      radio.tabIndex = isActive ? 0 : -1;
    });

    radios[nextIndex].focus();
  };

  // --- ATTACH LISTENER ---
  container.addEventListener('keydown', onKeyDown);

  // --- CLEANUP (important in class components) ---
  container._cleanupKeyboardNav = () => {
    container.removeEventListener('keydown', onKeyDown);
  };
};


  render() {
    //Setting the Value from the Props
    const { address = {}, addrFormType = 'Add', modalName = '', addressLine3 = '' } = this.state;

    let { address: initialaddresss = {}, device = '' } = this.props;
    let {
      addressBook: {
        postalData: { district: distNew = '', invalidpostalcode = false, state: stateNew = '' } = {}
      } = {},
      name,
      luxeFlags = {},
      isPageType = ''
    } = this.props;
    let { isThemeEnable } = luxeFlags;
    let {
      id = '',
      firstName = '',
      lastName = '',
      addressPoc = '',
      line1 = '',
      line2 = '',
      line3 = '',
      landmark = '',
      town = '',
      district = '',
      state = '',
      postalCode = '',
      phone = '',
      altMobNum = '',
      codEligible = '',
      exchangeService = '',
      selectedAddressType = 'HOME',
      customAddressType = '',
      defaultAddress = '',
      country = {}
    } = address;
    customAddressType = getDecodedString(customAddressType);
    let { isocode = 'IN' } = country;
    let cityDistrict = distNew ? distNew : district;
    cityDistrict = invalidpostalcode ? '' : cityDistrict;
    let newState = stateNew ? stateNew : state;
    newState = invalidpostalcode ? '' : newState;
    const {
      location: { pathname }
    } = window;
    let luxe = name === 'luxe' && isThemeEnable === 'ON';
    if (pathname === '/my-account/address-book' && device !== 'mobile') luxe = false;

    return (
      <ThemeProvider theme={theme}>
        {luxe ? (
          <div className="address-content">
            <form
              className="add-address-form"
              id="addAddressFormLuxe"
              onKeyDown={(e) => {
              const t = e.target; 
              const tag = t && t.tagName ? t.tagName.toLowerCase() : "";
              const type = t && t.getAttribute ? (t.getAttribute("type") || "") : "";

              const allow =
                tag === "textarea" ||
                (tag === "input" &&
                  ["text", "search", "email", "tel", "url", "number", "password"].indexOf(type) !== -1);

              if (e.key === "Enter" && !allow) {
                e.preventDefault();
                e.stopPropagation();
              }
            }}
              onSubmit={e => { 
                e.preventDefault();
                this.addAddressSubmit(
                  e,
                  postalCode,
                  addressPoc,
                  line1,
                  cityDistrict,
                  phone,
                  line2,
                  town,
                  landmark,
                  altMobNum,
                  defaultAddress,
                  newState,
                  selectedAddressType,
                  customAddressType,
                  luxe
                )
                if (!this.checkMandatoryFields()) {
                  readAloudFormErrors(".address-error-msg");
                  return;
                }
              }}
            >
              <div className="add-address-form-container">
                <div className="addNewAddressTextLuxe">
                  <div onClick={this.goBack}>
                    <BackArrow />
                  </div>
                  <div>
                    <Text variant="T4" color="Nero" weight="bold" textTransform="is-uppercase">
                      Address
                    </Text>
                  </div>
                  <button
                    type='button'
                    onClick={e => this.showDialog(e)}
                    className={'rilrtl-button button mobaddaddr-reset-luxe'}
                    id="reset-luxe-btn"
                    aria-label="Reset Address"
                  >
                    <strong>Reset</strong>
                  </button>
                </div>

                {device !== 'mobile' && (
                  <div className="addNewAddressText">
                    {this.props.addrFormType == 'Edit' ? 'Edit Address Details' : 'Add new address'}
                  </div>
                )}
                <div className="contact-info-address">
                  <Text variant="T4" color="Nero" weight="bold" textTransform="is-capitalized">
                    {luxe ? 'CONTACT INFO' : 'Contact Info'}
                  </Text>
                  <div className="mobaddadddr-input">
                    <Input
                      type="text"
                      defaultValue={addressPoc}
                      onChange={e => {
                        this.handleInputChange({ addressPoc: e });
                      }}
                      name="addressPoc"
                      size="32"
                      maxLength="129"
                      label="Name"
                      validationError={this.state.errAddressPoc ? true : false}
                      ariaLabel="Name"
                      labelHidden={true}
                    />
                    <span className="address-error-msg" aria-live='assertive'>{this.state.errAddressPoc}</span>
                  </div>

                  <div className="mobaddadddr-input">
                    <Input
                      type="tel"
                      defaultValue={phone}
                      onChange={e => this.handleInputChange({ phone: e })}
                      name="phone"
                      size="32"
                      maxLength="10"
                      label="Phone Number (+91)"
                      validationError={this.state.errMobileNum ? true : false}
                      ariaLabel="Phone Number (+91)"
                      labelHidden={true}
                    />
                    <div
                      ref={el => {
                        this.errorMessages = el;
                      }}
                      className="address-error-msg"
                      aria-live='assertive'
                    >
                      {this.state.errMobileNum}
                    </div>
                  </div>
                </div>
                <div className="address-info-section">
                  <Text variant="T4" color="Nero" weight="bold" textTransform="is-capitalized">
                    {luxe ? 'ADDRESS INFO' : 'Address Info'}
                  </Text>
                  <input type="hidden" name="country.isocode" value={isocode} />
                  <div className="mobaddadddr-input">
                    <div className="cityPincode">
                      <div className="pincode">
                        <Input
                          type="number"
                          numericOnly
                          defaultValue={postalCode}
                          onChange={e => this.handlePostalCode({ postalCode: e })}
                          name="postalCode"
                          size="32"
                          maxLength="6"
                          label="Pincode"
                          validationError={
                            this.state.errPinCode || invalidpostalcode ? true : false
                          }
                          ariaLabel="Pincode"
                          labelHidden={true}
                        />
                        {invalidpostalcode ? (
                          <span className="address-error-msg" aria-live='assertive'>
                            {' '}
                            Sorry, the pincode entered is either invalid or non serviceable{' '}
                          </span>
                        ) : (
                          this.state.errPinCode && (
                              <span className="address-error-msg" aria-live='assertive'>{this.state.errPinCode}</span>
                          )
                        )}
                      </div>
                      <div className="city">
                        <Input
                          type="text"
                          defaultValue={cityDistrict}
                          onChange={e => this.handleInputChange({ district: e })}
                          name="district"
                          size="32"
                          maxLength="30"
                          readOnly
                          label="City"
                          validationError={!cityDistrict || invalidpostalcode ? true : false}
                          ariaLabel="City"
                          labelHidden={true}
                        />
                        {invalidpostalcode ? (
                          <span className="address-error-msg" aria-live='assertive'> Please enter a City/District </span>
                        ) : this.state.errCityDistrict && !cityDistrict ? (
                            <span className="address-error-msg" aria-live='assertive'>{this.state.errCityDistrict}</span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="mobaddadddr-input">
                    <Input
                      type="text"
                      defaultValue={newState}
                      onChange={e => this.handleInputChange({ state: e })}
                      readOnly
                      name="state"
                      size="32"
                      maxLength="30"
                      label="State"
                      validationError={this.state.errState ? true : false}
                      ariaLabel="State"
                      labelHidden={true}
                    />
                    {this.state.errState && !newState ? (
                      <span className="address-error-msg" aria-live='assertive'>{this.state.errState}</span>
                    ) : null}
                  </div>

                  <div className="mobaddadddr-input">
                    <Input
                      type="text"
                      defaultValue={line2}
                      onChange={e => this.handleInputChange({ line2: e })}
                      name="line2"
                      size="32"
                      maxLength="200"
                      label="Locality / Area / Street"
                      validationError={this.state.errAddressLine2 ? true : false}
                      ariaLabel="Locality / Area / Street"
                      labelHidden={true}
                    />
                    <span className="address-error-msg" aria-live='assertive'>{this.state.errAddressLine2}</span>
                  </div>
                  <div className="mobaddadddr-input">
                    <Input
                      type="text"
                      defaultValue={addressLine3}
                      onChange={e => this.handleInputChange({ line1: e })}
                      name="line1"
                      size="32"
                      maxLength="30"
                      label="Flat no / Building Name"
                      validationError={this.state.errAddressLine1 ? true : false}
                      ariaLabel="Flat no / Building Name"
                      labelHidden={true}
                    />
                    <span className="address-error-msg" aria-live='assertive'>{this.state.errAddressLine1}</span>
                  </div>

                  <div className="mobaddadddr-input">
                    <Input
                      type="text"
                      defaultValue={landmark}
                      onChange={e => this.handleInputChange({ landmark: e })}
                      name="landmark"
                      size="32"
                      maxLength="30"
                      label="Landmark (optional)"
                      validationError={this.state.errLandmark ? true : false}
                      ariaLabel="Landmark (optional)"
                      labelHidden={true}
                    />
                  </div>
                </div>

                <div className="mobaddadddr-input typeOfAdd">
                  <p className="input-box radioButton">
                    <Text variant="T4" color="Nero" weight="bold" textTransform="is-capitalized">
                      {luxe ? 'TYPE OF ADDRESS' : 'Type of Address'}
                    </Text>
                    <div className="addressTypeButton">
                      <input
                        type="radio"
                        className="radioButton"
                        name="selectedAddressType"
                        checked={selectedAddressType === 'HOME' ? true : false}
                        value="HOME"
                        //checked={selectedAddressType == "HOME" ? true : false}
                        onChange={e => this.handleInputChange({ selectedAddressType: 'HOME' })}
                        aria-label="selectedAddressType"
                      />
                      <Icon
                        ariaLabel='address selection'
                        icon={
                          selectedAddressType === 'HOME'
                            ? 'icon-Radio-Button-Selected'
                            : 'icon-Radio-Button'
                        }
                        styles={style}
                      />
                      <label className="radio-text">Home</label>
                      <input
                        type="radio"
                        className="radioButton"
                        name="selectedAddressType"
                        checked={selectedAddressType === 'WORK' ? true : false}
                        value="WORK"
                        //checked={selectedAddressType == "WORK" ? true : false}
                        onChange={e => this.handleInputChange({ selectedAddressType: 'WORK' })}
                        aria-label="selectedAddressType"
                      />
                      <Icon
                        ariaLabel='address selection'
                        icon={
                          selectedAddressType === 'WORK'
                            ? 'icon-Radio-Button-Selected'
                            : 'icon-Radio-Button'
                        }
                        styles={style}
                      />
                      <label className="radio-text"> {luxe ? 'Office' : 'Work'}</label>
                      <input
                        type="radio"
                        className="radioButton"
                        name="selectedAddressType"
                        checked={selectedAddressType === 'OTHER' ? true : false}
                        value="OTHER"
                        //checked={selectedAddressType == "OTHERS" ? true : false}
                        onChange={e => this.handleInputChange({ selectedAddressType: 'OTHER' })}
                        aria-label="selectedAddressType"
                      />
                      <Icon
                        ariaLabel='address selection'
                        icon={
                          selectedAddressType === 'OTHER'
                            ? 'icon-Radio-Button-Selected'
                            : 'icon-Radio-Button'
                        }
                        styles={style}
                      />
                      <label className="radio-text">Others</label>
                    </div>
                  </p>
                </div>
                {selectedAddressType == 'OTHER' ? (
                  <div className="mobaddadddr-input otherAddress">
                    <Input
                      type="text"
                      defaultValue={customAddressType}
                      onChange={e => this.handleInputChange({ customAddressType: e })}
                      name="customAddressType"
                      size="32"
                      maxLength="30"
                      label="Enter Address name"
                      validationError={this.state.errCustomAddress ? true : false}
                    />
                    <span className="address-error-msg" aria-live='assertive'>{this.state.errCustomAddress}</span>
                  </div>
                ) : (
                  ''
                )}
                <Dialog
                  showDialog={this.state.removeFromBagModal}
                  type="drawer"
                  onCancel={() => this.hideDialog()}
                  ariaLabel="Reset Address"
                >
                  <div id="resetDialog">
                    <ResetAddressLuxe
                      hideDialog={() => this.hideDialog()}
                      resetButton={e => this.handleResetButton(e, initialaddresss, luxe)}
                      initialaddresss={initialaddresss}
                    ></ResetAddressLuxe>
                  </div>
                </Dialog>

                {!(this.props.enableGST && isPageType === 'shipping') && isPageType != 'checkout' && (
                  <div className="mobaddaddr-default defaultAddressMsite">
                    <span>
                      <Icon
                        ariaLabel='default address selection'
                        icon={
                          this.state.defaultBoxChecked ? 'icon-Checkbox-Selected' : 'icon-Check-box'
                        }
                        styles={luxe ? luxeStyle : style}
                      />

                      <input
                        type="checkbox"
                        value={this.state.defaultBoxChecked}
                        defaultChecked={this.state.defaultBoxChecked}
                        name="defaultAddress"
                        checked={this.state.defaultBoxChecked}
                        onChange={e => {}}
                        onClick={e => {
                          let newAdresss = Object.assign({}, this.state.address);
                          newAdresss.defaultAddress = !this.state.address.defaultAddress;

                          this.setState({
                            defaultBoxChecked: !this.state.defaultBoxChecked,
                            address: newAdresss
                          });

                          defaultAddress = !defaultAddress;
                          //this.setState({defaultBoxChecked : !this.state.defaultBoxChecked})}
                        }}
                        onKeyDown={e => {   
                           if (e.key === "Enter") {
                            e.preventDefault();
                            e.stopPropagation();
                           let newAdresss = Object.assign({}, this.state.address);
                          newAdresss.defaultAddress = !this.state.address.defaultAddress;

                          this.setState({
                            defaultBoxChecked: !this.state.defaultBoxChecked,
                            address: newAdresss
                          });

                          defaultAddress = !defaultAddress;
                          //this.setState({defaultBoxChecked : !this.state.defaultBoxChecked})}
                        }}}
                        aria-label="Make as default Address"
                      />
                      <label aria-hidden="true"> Make as default Address</label>
                    </span>
                  </div>
                )}
              </div>
              <div className="mobaddaddr-type">
                <button type="submit" className="rilrtl-button button mobaddaddr-save" tabIndex={0} aria-label="Save Address">
                  <strong>Save Address</strong>
                </button>
              </div>
            </form>
          </div>
        ) : (
          <div>
            <form
              className="add-address-form"
              id="addAddressForm"
            onKeyDown={(e) => {
             // Allow Enter in multiline/text inputs; block elsewhere to avoid implicit submit
              const t = e.target; // plain JS, no TS casts
              const tag = t && t.tagName ? t.tagName.toLowerCase() : "";
              const type = t && t.getAttribute ? (t.getAttribute("type") || "") : "";

              const allow =
                tag === "textarea" ||
                (tag === "input" &&
                  ["text", "search", "email", "tel", "url", "number", "password"].indexOf(type) !== -1);

              if (e.key === "Enter" && !allow) {
                e.preventDefault();
                e.stopPropagation();
              }
            }}
              onSubmit={e => {
                 e.preventDefault();

                this.addAddressSubmit(
                  e,
                  postalCode,
                  addressPoc,
                  line1,
                  cityDistrict,
                  phone,
                  line2,
                  town,
                  landmark,
                  altMobNum,
                  defaultAddress,
                  newState,
                  selectedAddressType,
                  customAddressType,
                  luxe
                )
                // if (!this.checkMandatoryFields()) {
                  readAloudFormErrors(".address-error-msg");
                //   return;
                // }
              }}
            >
              <div className="add-address-form-container">
                <div className="addNewAddressText" aria-label={ addrFormType === "Edit" ? "Edit Address Details" : "Add new address"} role='heading' aria-level={3}>
                  {addrFormType === 'Edit' ? 'Edit Address Details' : 'Add new address'}{' '}
                </div>

                <div className="mobaddadddr-input">
                  <TextField
                    type="text"
                    value={addressPoc}
                    onChange={this.props.gstBusinessName ? undefined : e => this.handleInputChange({ addressPoc: e.target.value })}
                    name="addressPoc"
                    size="32"
                    maxLength="129"
                    fullWidth
                    autoComplete={'name'}
                    label="Name"
                    style={styles.inputStyle}
                    floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                    floatingLabelStyle={styles.floatingLabelShrinkStyle}
                    variant="standard"
                    required
                    InputLabelProps={{ 'aria-hidden': true }}
                    inputProps={{ 'aria-label': 'Name', 'aria-describedby':'name-error-msg' }}
                    InputProps={{ readOnly: !!this.props.gstBusinessName }}
                  />
                    <span aria-live='assertive' aria-atomic='true' id='name-error-msg' className="address-error-msg" style={{
                      height: this.state.errAddressPoc ? '' : 0,
                      width: this.state.errAddressPoc ? '' : 0,
                      opacity: this.state.errAddressPoc ? '' : 0,
                      pointerEvents: this.state.errAddressPoc ? '' : 'none',
                    }}>
                      {this.state.errAddressPoc}
                    </span>
                    {/* <span aria-hidden="true"><span id='name-error-msg' className="address-error-msg" aria-live='assertive'>{this.state.errAddressPoc}</span></span> */}
                </div>

                <div className="mobaddadddr-input">
                  <TextField
                    value={phone}
                    onChange={e => this.handleInputChange({ phone: e.target.value })}
                    name="phone"
                    size="32"
                    maxLength="10"
                    label="Mobile"
                    fullWidth
                    autoComplete={'tel'}
                    style={styles.inputStyle}
                    floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                    floatingLabelStyle={styles.floatingLabelShrinkStyle}
                    type="tel"
                    variant="standard"
                    required
                    InputLabelProps={{ 'aria-hidden': true }}
                    inputProps={{
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      // 'aria-label': `Mobile number +9 1 ${phone.replace(/\d/g, '$& ').trim()}`
                      'aria-label': 'Mobile Number',
                      'aria-describedby':'mobileNum-error-msg' 
                    }}
                  />
                    <span 
                      ref={el => {
                        this.errorMessages = el;
                      }}
                        aria-live='assertive' 
                        aria-atomic='true' className="address-error-msg"
                        id='mobileNum-error-msg' style={{
                        height: this.state.errMobileNum ? '' : 0,
                        width: this.state.errMobileNum ? '' : 0,
                        opacity: this.state.errMobileNum ? '' : 0,
                        pointerEvents: this.state.errMobileNum ? '' : 'none',
                      }}>
                      {this.state.errMobileNum}
                    </span>
                    {/* <div aria-hidden="true"><div
                      ref={el => {
                        this.errorMessages = el;
                      }}
                      className="address-error-msg"
                      aria-live='assertive'
                      id='mobileNum-error-msg'
                    >
                      {this.state.errMobileNum}
                    </div></div> */}
                </div>

                <div className={`${device === 'mobile' ? 'address-info-section' : ''}`}>
                  <input type="hidden" name="country.isocode" value={isocode} />
                  <div className="mobaddadddr-input">
                    <TextField
                      type="number"
                      numericOnly
                      value={postalCode}
                      onChange={e => this.handlePostalCode({ postalCode: e.target.value })}
                      name="postalCode"
                      size="32"
                      maxLength="6"
                      autoComplete={'postal-code'}
                      label="Pin Code"
                      fullWidth
                      style={styles.inputStyle}
                      floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                      floatingLabelStyle={styles.floatingLabelShrinkStyle}
                      variant="standard"
                      required
                      InputLabelProps={{ 'aria-hidden': true }}
                      inputProps={{ 'aria-label': 'Pin Code', 'aria-describedby':'pincode-error-msg'  }}
                    />
                      <span aria-live='assertive' aria-atomic='true' id='pincode-error-msg' className="address-error-msg" style={{
                        height: (invalidpostalcode || this.state.errPinCode) ? '' : 0,
                        width: (invalidpostalcode || this.state.errPinCode) ? '' : 0,
                        opacity: (invalidpostalcode || this.state.errPinCode) ? '' : 0,
                        pointerEvents: (invalidpostalcode || this.state.errPinCode) ? '' : 'none',
                      }}>
                        {invalidpostalcode ? "Sorry, the pincode entered is either invalid or non serviceable" : this.state.errPinCode}
                      </span>
                     {/* <span aria-hidden="true"> <span id='pincode-error-msg' className="address-error-msg" aria-live='assertive'>
                        {invalidpostalcode ? "Sorry, the pincode entered is either invalid or non serviceable" : this.state.errPinCode}
                      </span></span> */}
                    {/* {invalidpostalcode ? (
                        <span id='pincode-error-msg' className="address-error-msg" aria-live='assertive'>
                        {' '}
                        Sorry, the pincode entered is either invalid or non serviceable{' '}
                      </span>
                    ) : (
                          <span id='pincode-error-msg' className="address-error-msg" aria-live='assertive'>{this.state.errPinCode}</span>
                    )} */}
                  </div>
                  <div className="mobaddadddr-input">
                    <TextField
                      value={line2}
                      onChange={e => this.handleInputChange({ line2: e.target.value })}
                      name="line2"
                      multiLine={true}
                      size="32"
                      maxLength="200"
                      rows={1}
                      rowsMax="4"
                      autoComplete="address-line2"
                      label="Locality / Area / Street"
                      style={styles.textAreaStyle}
                      floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                      floatingLabelStyle={styles.floatingLabelShrinkStyleTextArea}
                      fullWidth
                      type="text"
                      variant="standard"
                      required
                      InputLabelProps={{ 'aria-hidden': true }}
                      inputProps={{ 'aria-label': 'Locality / Area / Street', 'aria-describedby':'line-2-error-msg'  }}
                    />
                      <span aria-live='assertive' aria-atomic='true' id='line-2-error-msg' className="address-error-msg" style={{
                        height: this.state.errAddressLine2 ? '' : 0,
                        width: this.state.errAddressLine2 ? '' : 0,
                        opacity: this.state.errAddressLine2 ? '' : 0,
                        pointerEvents: this.state.errAddressLine2 ? '' : 'none',
                      }}>
                        {this.state.errAddressLine2}
                      </span>
                    {/* <span aria-hidden="true"><span id='line-2-error-msg' className="address-error-msg" aria-live='assertive'>{this.state.errAddressLine2}</span></span> */}
                  </div>

                  <div className="mobaddadddr-input">
                    <TextField
                      value={addressLine3}
                      onChange={e => this.handleInputChange({ line1: e.target.value })}
                      name="line1"
                      size="32"
                      maxLength="30"
                      autoComplete="address-line1"
                      label="Flat number / Building Name"
                      fullWidth
                      style={styles.inputStyle}
                      floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                      floatingLabelStyle={styles.floatingLabelShrinkStyle}
                      type="text"
                      variant="standard"
                      required
                      InputLabelProps={{ 'aria-hidden': true }}
                      inputProps={{ 'aria-label': 'Flat number / Building Name', 'aria-describedby':'line-1-error-msg'  }}
                    />
                      <span aria-live='assertive' aria-atomic='true' id='line-1-error-msg' className="address-error-msg" style={{
                        height: this.state.errAddressLine1 ? '' : 0,
                        width: this.state.errAddressLine1 ? '' : 0,
                        opacity: this.state.errAddressLine1 ? '' : 0,
                        pointerEvents: this.state.errAddressLine1 ? '' : 'none',
                      }}>
                        {this.state.errAddressLine1}
                      </span>
                    {/* <span aria-hidden="true"><span id='line-1-error-msg' className="address-error-msg"  aria-live='assertive'>{this.state.errAddressLine1}</span></span> */}
                  </div>

                  <div className="mobaddadddr-input">
                    <TextField
                      value={landmark}
                      onChange={e => this.handleInputChange({ landmark: e.target.value })}
                      name="landmark"
                      size="32"
                      maxLength="30"
                      autoComplete={'Off'}
                      label="Landmark"
                      fullWidth
                      style={styles.inputStyle}
                      floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                      floatingLabelStyle={styles.floatingLabelShrinkStyle}
                      type="text"
                      variant="standard"
                      required
                      InputLabelProps={{ 'aria-hidden': true }}
                      inputProps={{ 'aria-label': 'Landmark', 'aria-describedby':'lm-error-msg'  }}
                    />
                      <span aria-live='assertive' aria-atomic='true' id='lm-error-msg' className="address-error-msg" style={{
                        height: this.state.errLandmark ? '' : 0,
                        width: this.state.errLandmark ? '' : 0,
                        opacity: this.state.errLandmark ? '' : 0,
                        pointerEvents: this.state.errLandmark ? '' : 'none',
                      }}>
                        {this.state.errLandmark}
                      </span>
                    {/* <span aria-hidden="true"><span id='lm-error-msg' className="address-error-msg" aria-live='assertive'>{this.state.errLandmark}</span></span> */}
                  </div>

                  <div className="mobaddadddr-input">
                    <TextField
                      value={cityDistrict}
                      readOnly
                      onChange={e => this.handleInputChange({ district: e.target.value })}
                      name="district"
                      size="32"
                      maxLength="30"
                      autoComplete="address-level2"
                      label="District/City"
                      fullWidth
                      style={styles.inputStyle}
                      floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                      floatingLabelStyle={styles.floatingLabelShrinkStyle}
                      type="text"
                      variant="standard"
                      required
                      InputLabelProps={{ 'aria-hidden': true }}
                      inputProps={{ 'aria-label': 'District / City', 'aria-describedby':'district-error-msg'  }}
                    />
                      <span aria-live='assertive' aria-atomic='true' id='district-error-msg' className="address-error-msg" style={{
                        height: (invalidpostalcode || this.state.errCityDistrict) ? '' : 0,
                        width: (invalidpostalcode || this.state.errCityDistrict) ? '' : 0,
                        opacity: (invalidpostalcode || this.state.errCityDistrict) ? '' : 0,
                        pointerEvents: (invalidpostalcode || this.state.errCityDistrict) ? '' : 'none',
                      }}>
                        {invalidpostalcode ? 'Please enter a City/District' : this.state.errCityDistrict}
                      </span>
                     {/* <span aria-hidden="true"><span id='district-error-msg' className="address-error-msg" aria-live='assertive'> {invalidpostalcode ? 'Please enter a City/District' : this.state.errCityDistrict} </span></span> */}
                    {/* {invalidpostalcode ? (
                      <span id='district-error-msg' className="address-error-msg" aria-live='assertive'> Please enter a City/District </span>
                    ) : (
                      <div>
                        {!cityDistrict && (
                          <span id='district-error-msg' className="address-error-msg" aria-live='assertive'>{this.state.errCityDistrict}</span>
                        )}
                      </div>
                    )} */}
                  </div>

                  <div className="mobaddadddr-input">
                    <TextField
                      value={newState}
                      readOnly
                      onChange={e => this.handleInputChange({ state: e.target.value })}
                      name="state"
                      size="32"
                      maxLength="30"
                      autoComplete="address-level1"
                      label="State"
                      style={styles.inputStyle}
                      floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                      floatingLabelStyle={styles.floatingLabelShrinkStyle}
                      fullWidth
                      type="text"
                      variant="standard"
                      required
                      InputLabelProps={{ 'aria-hidden': true }}
                      inputProps={{ 'aria-label': 'State', 'aria-describedby':'state-error-msg'  }}
                      />                      
                      <span aria-live='assertive' aria-atomic='true' id='state-error-msg' className="address-error-msg" style={{
                        height: !newState ? '' : 0,
                        width: !newState ? '' : 0,
                        opacity: !newState ? '' : 0,
                        pointerEvents: !newState ? '' : 'none',
                      }}>
                        {!newState ? this.state.errState : ''}
                      </span>
                    {/* <span aria-hidden="true"><span id='state-error-msg' className="address-error-msg" aria-live='assertive'>{!newState ? this.state.errState : ''}</span></span> */}
                      {/* {!newState && <span id='state-error-msg' className="address-error-msg" aria-live='assertive'>{this.state.errState}</span>} */}
                  </div>
                </div>

                <div className="mobaddadddr-input typeOfAdd" ref={this.keyboardNavForAddressType}>
                    <div className="input-box radioButton" role='radiogroup' aria-label='Address Type'> 
                      <div id="addressTypeLabel" className="radioButton-header" role="radiogroup">Address Type</div>
                      <input
                        type="radio"
                        className="radioButton"
                        name="selectedAddressType"
                        //checked={selectedAddressType == "HOME" ? true : false}
                        value="HOME"
                        checked={selectedAddressType === 'HOME'}
                        onChange={() => this.handleInputChange({ selectedAddressType: 'HOME' })}
                        aria-checked={selectedAddressType === 'HOME'}
                        role="radio"
                        id="homeRadio"
                        aria-label='HOME'
                      />
                      <label htmlFor="homeRadio" className="radio-text" aria-hidden={true}>Home</label>
                      <input
                        type="radio"
                        className="radioButton"
                        name="selectedAddressType"
                        //checked={selectedAddressType == "WORK" ? true : false}
                        value="WORK"
                        checked={selectedAddressType === 'WORK'}
                        onChange={() => this.handleInputChange({ selectedAddressType: 'WORK' })}
                        aria-checked={selectedAddressType === 'WORK'}
                        role="radio"
                        id="workRadio"
                        aria-label='WORK'
                      />
                      <label htmlFor="workRadio" className="radio-text" aria-hidden={true}>Work</label>
                      <input
                        type="radio"
                        className="radioButton"
                        name="selectedAddressType"
                        //checked={selectedAddressType == "OTHERS" ? true : false}
                        value="OTHER"
                        checked={selectedAddressType === 'OTHER'}
                        onChange={() => this.handleInputChange({ selectedAddressType: 'OTHER' })}
                        aria-checked={selectedAddressType === 'OTHER'}
                        role="radio"
                        id="otherRadio"
                        aria-label='OTHER'
                      />
                      <label htmlFor="otherRadio" className="radio-text" aria-hidden={true}>Others</label>
                    </div>
                  </div>

                {selectedAddressType == 'OTHER' ? (
                  <div className="mobaddadddr-input otherAddress">
                    <TextField
                      type="text"
                      value={customAddressType}
                      onChange={e => this.handleInputChange({ customAddressType: e.target.value })}
                      name="customAddressType"
                      size="32"
                      maxLength="30"
                      fullWidth
                      autoComplete={'Off'}
                      floatingLabelText="Enter Address name"
                      style={styles.inputStyle}
                      floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                      floatingLabelStyle={styles.floatingLabelShrinkStyle}
                    />
                      <span className="address-error-msg" aria-live='assertive'>{this.state.errCustomAddress}</span>
                  </div>
                ) : (
                  ''
                )}

                  {!(this.props.enableGST && isPageType === 'shipping') && isPageType != 'checkout' && (
                    <div className="mobaddaddr-default defaultAddressMsite">
                    <span>
                      <input
                        id="label-feild"
                        type="checkbox"
                        value={this.state.defaultAddress}
                        defaultChecked={defaultAddress}
                        name="defaultAddress"
                        checked={this.state.defaultAddress}
                
                        onClick={e => {
                          let newAdresss = Object.assign({}, this.state.address); //creating copy of object
                          newAdresss.defaultAddress = !this.state.address.defaultAddress; //updating value
                          this.setState({
                            defaultBoxChecked: !this.state.defaultBoxChecked,
                            address: newAdresss,
                            defaultAddress : !this.state.defaultAddress
                          });

                          defaultAddress = !defaultAddress;
                          //this.setState({defaultBoxChecked : !this.state.defaultBoxChecked})}
                        }}
                           onKeyDown={e => {   
                             if (e.key === "Enter") {
                            e.preventDefault();
                            e.stopPropagation();
                           let newAdresss = Object.assign({}, this.state.address);
                          newAdresss.defaultAddress = !this.state.address.defaultAddress;

                          this.setState({
                            defaultBoxChecked: !this.state.defaultBoxChecked,
                            address: newAdresss,
                            defaultAddress : !this.state.defaultAddress
                          });

                          defaultAddress = !defaultAddress;
                          //this.setState({defaultBoxChecked : !this.state.defaultBoxChecked})}
                        }}}
                        aria-label='Make as default Address'
                      />
                      <label htmlFor='label-feild' aria-hidden="true"> Make as default Address</label>
                    </span>
                  </div>
                )}
              </div>
              <div className="mobaddaddr-type">
                <button
                  type='button'
                  onClick={e => {
                    this.handleResetButton(e, initialaddresss)
                    this.setState({
                      resetSuccessMessage: `Reset done successfully`,
                    })
                    setTimeout(()=>{
                      this.setState({
                        resetSuccessMessage: ''
                      })
                    },2000)
                  }}
                  className="rilrtl-button button mobaddaddr-reset"
                  tabIndex={0}
                  aria-label="Reset Address"
                >
                  <strong>Reset</strong>
                    <strong style={{
                      height: 0,
                      width: 0,
                      overflow: 'hidden',
                      pointerEvents: 'none',
                      opacity: 0,
                      position: 'absolute'
                    }} role='alert' aria-live='alert' aria-atomic='true'>{this.state.resetSuccessMessage}</strong>
                </button>
                <button type="submit" className="rilrtl-button button mobaddaddr-save" tabIndex={0} aria-label="Save" onClick={(e)=>{
                  e.preventDefault();
                  const target = e.target;
                  this.checkIfFieldsEmptyOnSubmit();


                  if(this.state.errPinCode){
                    return
                  }

                  // this call needs to be wrapped in a setTimeout to delay it to the next tick, because the above functions sets error message for multiple state variables including errLandmark, and if this function is called immediately the updated changes wont be reflected instantly and user will be able to submit the form without entering the landmark
                    setTimeout(() => {
                      this.addAddressSubmit(
                        e,
                        postalCode,
                        addressPoc,
                        line1,
                        cityDistrict,
                        phone,
                        line2,
                        town,
                        landmark,
                        altMobNum,
                        defaultAddress,
                        newState,
                        selectedAddressType,
                        customAddressType,
                        luxe
                      )
                    }, 0)

                }}>
                  <strong>Save</strong>
                </button>
              </div>
            </form>
          </div>
        )}
      </ThemeProvider>
    );
  }
}

const mapStatetoProps = state => {
  const { addressBook = [], personalInfo = [], httpError = {}, flags = {}, cartItem = [] } = state;

  return {
    addressBook,
    personalInfo,
    httpError,
    luxeFlags: getLuxeFlags(flags),
    name: getCurrentStore(state),
    cartItem,
    enableGST: getGSTFlag(state, 'cart')
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addAddress: (formData, callback) => {
      dispatch(addAddress(formData, callback));
      dispatch(hideModal('add-new-address'));
      dispatch(hideModal('address-add'));
    },
    editAddressCheckout: (formData, cb) => {
      dispatch(editAddress(formData, cb));
      dispatch(getCart({ isRequestOrginIsBrowser: true }));
      dispatch(hideModal('address-edit'));
    },
    editAddress: (formData, callback) => {
      dispatch(editAddress(formData, callback));
      dispatch(hideModal('address-edit'));
    },
    getlocationFromPostalCode: (postalCodeObj) => {
      dispatch(postalCodeFetch(postalCodeObj));
    },
    setPostalCode: (postalCodeData = {}) => {
      dispatch(setPostalCode(postalCodeData));
    },
    setPinCode: (pincode = '') => {
      dispatch(setPinCode(pincode));
    },
    resetPostalData: () => {
      dispatch(resetPostalData());
    },
    fetchCartItemsEDDFromClient: pincode => dispatch(fetchCartItemsEDDFromClient(pincode)),
    setDelivery: id => setDelivery(id, dispatch),
    setCheckedAddress: (id, postalCode, index, edd, isStoreAddress) => {
      dispatch(setCheckedAddress(id, postalCode, index, edd, isStoreAddress));
    },
    updateAddressOnCart: (obj) => {
      dispatch(changeAddressSelectionOnCart(obj));
    }  
  };
};

export default AddAddress = connect(mapStatetoProps, mapDispatchToProps)(AddAddress);
// Abhishek's Changes